import type { SelectOption } from '@/js/account/components/base/BaseSelect.vue';

export const LIBRARY_SORT_OPTIONS: SelectOption[] = [
  { label: 'Newest', value: 'newest' },
  { label: 'Last updated', value: 'last_updated' },
  { label: 'A to Z', value: 'a_to_z' },
  { label: 'Z to A', value: 'z_to_a' },
];
